import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, UpdateAuthorizedIpsDialogueHandler } from './types';
import UpdateAuthorizedIpsContext from './UpdateAuthorizedIpsContext';

const { ConfirmationDialogue } = vp;

type AuthorizedIpsDialogueProps = {
  handleDialogue: DialogueHandler<UpdateAuthorizedIpsDialogueHandler>;
};

type FC = FunctionComponent<AuthorizedIpsDialogueProps>;

const UpdateAuthorizedIpsDialogue: FC = ({ handleDialogue }: AuthorizedIpsDialogueProps) => {
  const { showUpdateSuccessAlert, showUpdateErrorAlert, UpdateError } = useContext(UpdateAuthorizedIpsContext);
  return useMemo(
    () => (
      <div>
        {/* Update Error */}
        <ConfirmationDialogue
          isVisible={showUpdateErrorAlert}
          title="Error! The Authorize IP Addresses were not updated."
          status="error"
          subTitle={`${UpdateError}`}
          confirm={{
            label: 'Back',
            action: () => handleDialogue({ type: 'update', state: 'error' }),
          }}
        />
        {/* Update Success */}
        <ConfirmationDialogue
          isVisible={showUpdateSuccessAlert}
          title="Success! The Authorize IP Addresses were updated."
          status="success"
          subTitle="Navigate back to Authorize IP Addresses."
          confirm={{
            label: 'Back to Authorize IP Addresses',
            action: () => handleDialogue({ type: 'update', state: 'success' }),
          }}
        />
      </div>
    ),
    [showUpdateSuccessAlert, showUpdateErrorAlert],
  );
};

export default UpdateAuthorizedIpsDialogue;
